export interface GoogleMapProps extends GoogleMapBase {
  defaultLocation?: PlaceDetails | undefined;
}

export interface GoogleMapBase {
  googleMapAPIKey: string;
  onLocationChange?: (place: PlaceDetails | undefined) => void;
}

//America
export const DEFAULT_LATITUDE = 40.7461796;
export const DEFAULT_LONGITUDE = -74.0120506;
export const DEFAULT_LOCATION_ADDRESS = 'Manhattan, NY 10036, United States';
export const DEFAULT_MAP_LOCATION: PlaceDetails = {
  latitude: DEFAULT_LATITUDE,
  longitude: DEFAULT_LONGITUDE,
  address: DEFAULT_LOCATION_ADDRESS,
};

export interface GoogleMapReduxState {
  place?: PlaceDetails;
}

export interface PlaceDetails {
  idAddress?: string; // An existing id in the db
  name?: string;
  address?: string;
  addressDirections?: string;
  longitude: number;
  latitude: number;
  viewport?: google.maps.LatLngBounds;
  placeID?: string; // A Google map ID of a place
  province?: string;
  city?: string;
  country?: string;
  postalCode?: string;
  googleMapUrl?: string;
}

export const USER_LOCATION_TIMEOUT_MS = 10000;
export const USER_LOCATION_MAX_AGE_MS = 300000;
